import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useFeatureAccessInsights } from '../featureAccessInsights';

export const useIsMyInsightsEntryPointVisible = (): boolean => {
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting('VivaEngagePremium') === true;
  const featureAccessInsights = useFeatureAccessInsights();

  return isVivaEngagePremium && featureAccessInsights?.canViewActivity === true;
};
